import React from 'react';
import ChatAssistant from '../components/ui/ChatAssistant';
import { useLanguage } from '../contexts/LanguageContext';
import { cn } from '@/lib/utils';
import useTranslation from '@/hooks/use-translation';

const Chatbot = () => {
  const { isRTL } = useLanguage();
  const { translate } = useTranslation();
  
  return (
    <div className="p-4 md:p-6 relative">
      <div className="mb-6 md:mb-8">
        <h1 className="text-xl md:text-2xl font-bold mb-2" dir={isRTL ? 'rtl' : 'ltr'}>
          {translate("AquaGenius AI Assistant")}
        </h1>
        <p className="text-muted-foreground" dir={isRTL ? 'rtl' : 'ltr'}>
          {translate("Your personal water expert - Get smart insights, water-saving tips, and personalized assistance.")}
        </p>
      </div>
      
      <ChatAssistant isFullPage={true} />
    </div>
  );
};

export default Chatbot;
